import { useEffect, useRef } from "react";
import "./home.css";
import { useReveal } from "./useReveal";
import { SiteNav } from "./sections/SiteNav";
import { Hero } from "./sections/Hero";
import { WhatItIs } from "./sections/WhatItIs";
import { WhyNow } from "./sections/WhyNow";
import { TheRoom } from "./sections/TheRoom";
import { TheDay } from "./sections/TheDay";
import { Beyond } from "./sections/Beyond";
import { Bergen } from "./sections/Bergen";
import { Partners } from "./sections/Partners";
import { Invite } from "./sections/Invite";
import { SiteFooter } from "./sections/SiteFooter";

export default function Home() {
  const ref = useRef(null);
  useReveal(ref);
  useEffect(() => {
    document.title = "Norwegian AI Summit 2027 — The Next Shift";
    const html = document.documentElement;
    const prev = [html.style.scrollBehavior, html.style.scrollPaddingTop, document.body.style.background];
    html.style.scrollBehavior = "smooth";
    html.style.scrollPaddingTop = "72px";
    document.body.style.background = "#070706";
    return () => {
      [html.style.scrollBehavior, html.style.scrollPaddingTop, document.body.style.background] = prev;
    };
  }, []);
  return (
    <div className="ns" id="top" ref={ref} data-testid="ns-home">
      <SiteNav />
      <main>
        <Hero />
        <WhatItIs />
        <WhyNow />
        <TheRoom />
        <TheDay />
        <Beyond />
        <Bergen />
        <Partners />
        <Invite />
      </main>
      <SiteFooter />
    </div>
  );
}
